module.exports = __webpack_public_path__ + "media/images/cplook/careerplug-3e1dead7bcce74fec69d7659d4f818dd.svg";